import React from 'react'
import { connect as connectRedux } from 'react-redux'
import { Map } from 'immutable'
import { getBoundActions } from '../../../actions/index'
import { createAbsolute } from '../../../services/url/index'
import { copyToClipboard } from '../../../services/share/index'
import Button, { TYPES } from '../../Button/index'
import Link from '../../Icon/icons/Link/index'

/**
 * @param {Object} props - The props
 * @param {Map} props.detailData - The content details data
 * @param {Map} props.staticText - The static text data
 * @returns {JSX.Element} DetailPageV3ActionCopyLink
 */

const DetailPageV3ActionCopyLink = (props) => {
  const {
    detailData = Map(),
    staticText,
    addToasty,
    resolver,
  } = props

  const handleShareUrlClick = () => {
    const url = detailData.get('path') || resolver.get('path')

    const absoluteUrl = createAbsolute(url)
    copyToClipboard(absoluteUrl)
    addToasty(staticText.get('copied'))
  }

  return (
    <Button
      type={TYPES.ICON}
      iconSvg={<Link />}
      onClick={handleShareUrlClick}
      className="detail-page-v3__action-button"
    >
      <span className="detail-page-v3__action-label">
        {staticText.get('copyLink')}
      </span>
    </Button>
  )
}

export default connectRedux((state) => ({
  resolver: state.resolver,
  staticText: state.staticText.getIn(['data', 'detailPageV3', 'data'], Map()),
}), (dispatch) => {
  const actions = getBoundActions(dispatch)
  return {
    addToasty: actions.toasty.addToasty,
    setEventDefault: actions.eventTracking.setEventDefault,
  }
})(DetailPageV3ActionCopyLink)
